import {ActiveFacetSet} from "./SearchReducer";

interface ExactFilter {
    field: string;
    value: string;
}

interface RangeFilter {
    field: string;
    lower: string;
    upper: string;
}

export interface SearchQuery {
    userId: string;
    query: string;
    targets: string[];
    exactFilters: Array<ExactFilter>;
    rangeFilters: Array<RangeFilter>;
}

function createExactFilters(filters?: ActiveFacetSet): ExactFilter[] {
    if (!filters) {
        return [];
    }
    return [
        ...Array.from(filters.createdYears).map((value) => ({field: "created_year", value})),
        ...Array.from(filters.presenters).map((value) => ({field: "presenters", value})),
        ...Array.from(filters.tags).map((value) => ({field: "tags", value}))
    ];
}

export function createSearchQuery(userId: string, query: string, targets: string[], filters?: ActiveFacetSet) {
    return {
        userId,
        query,
        targets,
        exactFilters: createExactFilters(filters),
        rangeFilters: []
    };
}
